module.exports = __webpack_public_path__ + "static/media/ilus-services-prototyping.338a2ae2.svg";